<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active"><a href="javascript:;">Report</a></li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('report_header_name') }} <!--<small class="ml-2">{{ this.$t('report_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:tasks="tasks.tasks"
						:workers="workers.workers"
						:products="products.products"
						:filterWorkers="filterWorkers"
						:getTasksByDate="getTasksByDate"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
    name: 'Report',
	components: {
		PageContentContainer,
	},
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
    computed: {
        ...mapState('task', ['tasks']),
        ...mapState('worker', ['workers']),
        ...mapState('product', ['products']),
    },
    methods: {
        ...mapActions('task', ['getTasksByDateRange']),
        ...mapActions('worker', ['getWorkers']),
        ...mapActions('product', ['getProducts']),
		getTasksByDate(startDate, endDate) {
			this.getTasksByDateRange({
				startDate: startDate,
				endDate: endDate
			});
		},
		filterWorkers(workers) {
			if (workers && workers.length) {
				return workers.filter(worker => {
					return worker.isActive;
				});
			}
		},
    },
    mounted() {
		if (!this.workers.length) {
			this.getWorkers();
		}
		if (!this.products.length) {
			this.getProducts();
		}
    }
}
</script>
